import ReportManager from './ReportManager';

export default ReportManager;
